import axios from "axios";

const endpoint_url = "/message/messageAudience/audienceDataList";

const getAudienceDataList = ({
  productData = null,
  locationData = null,
  ageRangeData = null,
  activeFromDateData = null,
  activeToDateData = null,
  newRegisterFromDateData = null,
  newRegisterToDateData = null
} = {}) => {
  const requestBody = {
    product_data: productData,
    location_data: locationData,
    age_range_data: ageRangeData,
    active_from_date: activeFromDateData,
    active_to_date: activeToDateData,
    new_register_from_date: newRegisterFromDateData,
    new_register_to_date: newRegisterToDateData
  };

  return new Promise((resolve, reject) => {
    axios
      .post(endpoint_url, requestBody)
      .then((response) => resolve(response))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

export default getAudienceDataList;
